module.exports = __webpack_public_path__ + "static/titleLogo-99bc67d3a8eb124aa061879ead508ba4.jpg";